import Welcome from './components/Welcome.vue';
import AuthComponent from './components/auth/AuthComponent.vue';
import BaseComponent from './components/BaseComponent.vue';


//-- 1. Admin --//
import IndexSettingUsers from './components/setting/user/index/admin.vue';
//~ End Admin ~


//-- 2. Officer --//
import HomeOfficer from './components/home/index/Officer.vue';
import IndexVerifyOfficer from './components/registration/verify/index/Officer.vue';
import ShowVerifyOfficer from './components/registration/verify/show/Officer.vue';
import IndexValidateOfficer from './components/registration/validate/index/Officer.vue';
import ShowValidateOfficer from './components/registration/validate/show/Officer.vue';
import RecapitulationKPOfficer from './components/recapitulation-internship/index/Officer.vue';
import SetFinishDateOfficer from './components/recapitulation-internship/create/Officer.vue';

import ShowKpOfficer from './components/registration/show/Officer.vue';
import IndexLetter from './components/manage/letter/index/Officer.vue';
import CreateLetter  from './components/manage/letter/create/Officer.vue';
import IndexRubric  from './components/manage/rubric/index/Officer.vue';
import CreateRubric  from './components/manage/rubric/create/Officer.vue';
import IndexFAQ  from './components/manage/faq/index/Officer.vue';


import RecapitulationLectureOfficer from './components/recapitulation-lecturer/index/Officer.vue';
import HelpStudent from './components/help-and-information/index/Student.vue';
//~ End Officer ~


//-- 3. Lecturer --//
import HomeLecturer from './components/home/index/Lecturer.vue';
//~ End Lecturer ~


//-- 4. Student --//
import HomeStudent from './components/home/index/Student.vue';
import KPCreateStudent from './components/registration/create/Student.vue';
import KPShowStudent from './components/registration/show/Student.vue';

//~ End Student ~

import Profile from './components/manage/profile/edit/User.vue'
import PageNotFound from './components/page/PageNotFound.vue';

export const routes = [
    {
        name: 'auth',
        path: '/auth',
        component: AuthComponent,
    },
    {
        name: 'auth-callback',
        path: '/auth/:provide/callback',
        component: AuthComponent
    },
    {
        name: 'welcome',
        path: '',
        component: Welcome
    },

    //-- 1. Admin --//-----------------------------------

    {
        path: '/setting-users',
        component: BaseComponent,
        children: [
            {
                name: 'setting-users.index',
                path: '',
                component: IndexSettingUsers,
                meta: {
                    breadcrumb: 'Kelola pengguna'
                },
            },
            // {
            //     name: 'setting-users.create',
            //     path: 'create',
            //     component: ProposalCreateComponent,
            //     meta: {
            //         roles: [5],
            //     },
            // },
            // {
            //     name: 'setting-users.read',
            //     path: 'read',
            //     component: ProposalReadComponent,
            //     meta: {
            //         roles: [1, 3, 4, 5],
            //     },
            // },
            // {
            //     name: 'setting-users.update',
            //     path: 'update',
            //     component: ProposalCreateComponent,
            //     meta: {
            //         roles: [5],
            //     },
            // },
        ]
    },

    //-- End Admin --//----------------------------------


    //-- 2. Officer --//-----------------------------------

    {
        name: 'home-officer',
        path: '/home-officer',
        component: HomeOfficer
    },
    {
        path: '/verify-officer',
        component: BaseComponent,
        children: [
            {
                name: 'verify-officer',
                path: '',
                component: IndexVerifyOfficer,
                meta: {
                    breadcrumb: 'Verifikasi'
                },
            },
            {
                name: 'verify-read',
                path: 'verify',
                component: ShowVerifyOfficer,
                meta: {
                    breadcrumb: 'Verifkasi Kerja Praktik'
                },
            },
        ]
    },
    {
        path: '/validate-officer',
        component: BaseComponent,
        children: [
            {
                name: 'validate-officer',
                path: '',
                component: IndexValidateOfficer,
                meta: {
                    breadcrumb: 'Verifikasi'
                },
            },
            {
                name: 'validate-read',
                path: 'verify',
                component: ShowValidateOfficer,
                meta: {
                    breadcrumb: 'Verifkasi Kerja Praktik'
                },
            },
        ]
    },
    {
        path: '/recapitulation-officer',
        component: BaseComponent,
        children: [
            {
                name: 'recapitulation-internship-officer',
                path: '',
                component: RecapitulationKPOfficer,
                meta: {
                    breadcrumb: 'Rekap'
                },

            },
            {
                name: 'recap-student-read',
                path: 'read',
                component: ShowKpOfficer,
                meta: {
                    breadcrumb: 'Liat detail'
                },
            },
            {
                name: 'set-finish-date',
                path: 'set-finish',
                component: SetFinishDateOfficer,
                meta: {
                    breadcrumb: 'Set tanggal selesai'
                },
            }
        ]
    },
    {
        name: 'recapitulation-lecture-officer',
        path: '/recapitulation-lecture-officer',
        component: RecapitulationLectureOfficer
    },
    {
        path: '/manage-letter',
        component: BaseComponent,
        children: [
            {
                name: 'manage-letter.index',
                path: '',
                component: IndexLetter,
                meta: {
                    breadcrumb: 'Kelola surat'
                },
            },
            {
                name: 'manage-letter.create',
                path: 'create',
                component: CreateLetter,
            },
        ]
    },
    {
        path: '/manage-rubric',
        component: BaseComponent,
        children: [
            {
                name: 'manage-rubric.index',
                path: '',
                component: IndexRubric,
                meta: {
                    breadcrumb: 'Kelola rubric'
                },
            },
            {
                name: 'manage-rubric.create',
                path: 'create',
                component: CreateRubric,
            },
        ]
    },
    {
        path: '/manage-faq',
        component: BaseComponent,
        children: [
            {
                name: 'manage-faq.index',
                path: '',
                component: IndexFAQ,
                meta: {
                    breadcrumb: 'Kelola faq'
                },
            },
            {
                name: 'manage-faq.create',
                path: 'create',
                component: CreateRubric,
            },
        ]
    },

    //-- End Officer --//----------------------------------


    //-- 3. Lecturer --//-----------------------------------

    {
        name: 'home-lecturer',
        path: '/home-lecturer',
        component: HomeLecturer
    },

    //-- End Lecturer --//----------------------------------


    //-- 4. Student --//-----------------------------------

    {
        path: '/home',
        component: BaseComponent,
        children: [
            {
                name: 'home',
                path: '',
                component: HomeStudent,
                meta: {
                    breadcrumb: 'Kerja praktik'
                },
            },
            {
                name: 'kp-create',
                path: 'create',
                component: KPCreateStudent,
                meta: {
                    breadcrumb: 'Daftar Kerja Praktik'
                },
            },
            {
                name: 'kp-update',
                path: 'update',
                component: KPCreateStudent,
                meta: {
                    breadcrumb: 'Daftar Kerja Praktik'
                },
            },
            {
                name: 'kp-read',
                path: 'read',
                component: KPShowStudent,
                meta: {
                    breadcrumb: 'Daftar Kerja Praktik'
                },
            }
        ]

    },
    {
        name: 'help-and-information-student',
        path: '/helping-you',
        component: HelpStudent,
        meta: {
            breadcrumb: 'Bantuan dan informasi'
        }
    },

    //-- End Student --//----------------------------------

    {
        path: '/profile',
        component: BaseComponent,
        children: [
            {
                name: 'profile',
                path: '',
                component: Profile,
                meta: {
                    breadcrumb: 'Profil'
                },
            },
        ]
    },

    { 
        path: "/404", 
        name:'PageNotFound', 
        component: PageNotFound 
    },

    { 
        path: "*", 
        redirect: "/404" 
    },

];